import { render, staticRenderFns } from "./NotificationAdd.vue?vue&type=template&id=1d7150b6&scoped=true"
import script from "./NotificationAdd.vue?vue&type=script&lang=js"
export * from "./NotificationAdd.vue?vue&type=script&lang=js"
import style0 from "./NotificationAdd.vue?vue&type=style&index=0&id=1d7150b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7150b6",
  null
  
)

export default component.exports